const uz_latin = {
  substantiate: 'Asoslab bering',
  archive: 'Arxiv',
  where_to: 'Qayerga',
  year: 'yil',
  salary_cert: 'Olingan daromadlar haqida malumotnoma',
  work_day: 'Ish kunlari',
  holiday: 'Bayram kunlari',
  weekend: 'Dam olish kunlari',
  dashboard_all: 'Barchasi',
  requiredpdf: "Faqat pdf fayl bo'lsin",
  requiredsize: 'Fayl hajmi 30 MB dan kam bo\'lishi kerak!',
  reysters: 'Katalog(Reestr)',
  IT: 'Axborot texnologiyalari: ',
  PM: 'Kadrlar boshqaruvi: ',
  tabel_acces_denied: "Ushbu tabel raqam bilan ishlashga ruhsatingiz yo'q.",
  signer: 'Imzolovchi',
  acceptable: 'Qabul qiluvchi',
  date: 'Imzolangan vaqt',
  uzauto: '«UzAuto Motors» AJ',
  rememberMe: 'Eslab qolish',
  itemsPerPageText: '',
  itemsPerPageAllText: 'Hammasi',
  company_id: 'Tashkilot',
  department_id: 'Bo\'lim',
  cancel: 'Bekor qilish',
  save: 'Saqlash',
  logout: 'Tizimdan chiqish',
  add: 'Qo\'shish',
  create: 'Yangi yaratish',
  created: 'Yaratilgan',
  changed: "О'zgartirildi",
  published: "E'lon qilindi",
  contacts: 'Murojaat uchun',
  edit: 'Tahrirlash',
  delete: 'O\'chirish',
  close: 'Yopish',
  select: 'Tanlang',
  required: '* bilan belgilangan maydonlar majburiy',
  input_required: 'Ushbu maydon majburiy',
  create_update_operation: 'Malumotlar bazasiga muvafaqqiyatli saqlandi',
  swal_title: 'Ushbu amalni bajarishga aminmisiz?',
  swal_text: 'Ushbu amalni keyin orqaga qaytarib bo\'lmaydi',
  swal_delete: 'Xa, o\'chirilsin!',
  swal_deleted: 'Sizning faylingiz o\'chirildi',
  swal_error_title: 'Xosh!',
  swal_error_text: 'Nimadir to\'g\'ri bo\'lmadi!',
  name_uz_latin: 'nomi o\'zbek lotin',
  name_uz_cyril: 'nomi o\'zbek kiril',
  name_ru: 'nomi ruscha',
  actions: "Amal",
  name: 'Nomi',
  description_uz_cyril: 'Izoh kiril',
  description_uz_latin: 'Izoh lotin',
  description_ru: 'Izoh ruscha',
  loadingText: 'Yuklanmoqda',
  noDataText: 'Ma\'lumot topilmadi!',
  created_at: 'Yaratilgan sana',
  updated_at: 'Taxrirlangan sana',
  created_by: 'Yaratgan foydalanuvchi:',
  updated_by: 'Taxrirlagan foydalanuvchi:',
  deleted_at: 'O\'chirilgan sana',
  code: 'Kodi',
  filter: 'Filtr',
  workflow: 'Hujjat aylanmasi',
  organization: 'Tashkilot',
  balance: 'Balans',
  created_documents: 'Yaratilgan hujjatlar',
  approved_documents: 'Tasdiqlangan hujjatlar',
  files: 'Fayllar',
  has_employee: 'Xodim biriktiladimi',
  start_date: 'yil kunidan',
  end_date: 'yil kunigacha',
  all_documents: 'Barcha hujjatlar',
  uploadFiles: 'Fayllarni yuklash',
  publish: 'E\'lon qilish',
  expectation: 'Kutilmoqda',
  today: 'Bugun',
  yesterday: 'Kecha',
  week: 'Hafta',
  oy: 'Oy',
  all: 'Hammasi',
  pending: 'Jarayonda',
  resolution_results: 'Yo\'naltirish natijalari',
  resolutions: 'Yo\'naltirishlar',
  executor: 'Ijro uchun kelgan hujjatlar',
  expired: 'Muddati tugayotgan',
  expired_done: 'Muddati tugagan',
  done: 'Bajarilgan',
  ready_templates: 'Tayyor andozalar',
  document_statistics: 'Hujjatlar aylanmasi statistikasi',
  document_chart: 'Hujjatlar aylanmasi diagrammada',
  qrCodeTitle: "Hujjatda ko'rsatilgan ma'lumotlarni tog'riligini tekshirish uchun QR-kodni mobil telefon orqali skaner qiling va korxona ma'lumotlar sayti orqali tekshiring.",
  look: 'Ko\'rish',
  download: 'Yuklab olish',
  more_than: 'dan ko\'p',
  and_less: 'dan kam',
  more_than_s: 'dan ko\'p simvol',
  and_less_s: 'dan kam simvol',
  confirm: 'Tasdiqlash',
  search: 'Qidiruv',
  searchInText: 'Tekstdan qidirish',
  document_transfer: 'Hujjat o\'tkazish',
  it_is_impossible: 'Ushbu hodimni ishdan olish yoki boshqa shtatga o\'tkazib bo\'lmaydi !!!',
  unfinished_documents: 'Tugatilmagan hujjatlari mavjud',
  documents_transferred: 'Hujjatlarni quyidagi hodimlarga o\'tkazish mumkin!',
  documents_transferred_employee: 'Hujjatlarni hodimning quyidagi shtatlariga o\'tkazish mumkin!',
  for_info: 'Ma\'lumot uchun',
  input: {
    required: 'Ushbu maydon majburiy',
    text: 'Matn kiritish',
  },
  gender: {
    gender: 'Jinsi',
    male: 'Erkak',
    female: 'Ayol',
  },

  message: {
    lsp_report: 'LSP Hisobotlari',
    lsp_index: "LSP bo'yicha hisobotlar",
    document_template: 'Hujjat shablonlari',
    document_types: 'Hujjat turlari',
    signers_group: "Imzo qoyuvchilar guruhi",
    positions: 'Shtatlar',
    noMessage: "Xabarlar yo\'q",
    noAlerts: 'Bildirishnomalar yo\'q',
    settings: 'Sozlamalar',
    create: 'Yangi hujjat yaratish',
    createInfo: "Yangi ma'lumotnoma yaratish",
    menu: 'Menyu',
    home: 'Asosiy sahifa',
    inbox: 'Qabul qilingan hujjatlar',
    draft: 'Qoralamalar',
    inbox: 'Kiruvchi hujjatlar',
    outbox: 'Chiquvchi hujjatlar',
    cancel: 'Bekor qilingan hujjatlar',
    sent: 'Yuborilgan hujjatlar',
    logout: 'Tizimdan chiqish',
    myCompany: 'Mening tashkilotim',
    profile: 'Mening profilim',
    tariffScale: 'Tariflar ko\'lami',
    coefficient: 'Ustamalar',
    departmentType: 'Bo\'imlar turlari',
    personalType: 'Personal turlari',
    positionType: 'Shtat turlari',
    expenceType: 'Xarajat turlari',
    requirementType: 'Talab turi',
    ranges: 'Diapazon',
    countries: 'Davlat',
    regions: 'Viloyat',
    natioanalities: 'Millat',
    districts: 'Shahar/tuman',
    requirement: 'Ishga qo\'yiladigan talablar',
    documents: 'Hujjatlar',
    all: 'Barchasi',
    report: 'Hisobot',
    reports: 'Hisobotlar',
    accessDepartment: 'Xodimlar ruxsati',
    accessType: 'Ruxsat turlari',
    requisites: 'Rekvizitlar',
    currency: 'Valyutalar',
    currencyHistory: 'Valyutalar tarixi',
    notifications: 'Xabarnomalar',
    znz: 'ZNZ Hisobotlari',
    znz_index: 'Harid jarayonlari bo\'yicha hisobotlar',
    firm_blank: 'Firma blanka'
  },
  requisites: {
    name_uz_latin: 'Nomi o\'zbek lotin',
    name_uz_cyril: 'Nomi o\'zbek kiril',
    name_ru: 'Nomi ruscha',
    name: 'Nomi',
    address_name_uz_latin: 'Manzil o\'zbek lotin',
    address_name_uz_cyril: 'Manzil o\'zbek kiril',
    address_name_ru: 'Manzil ruscha',
    address: 'Manzili',
    INN: 'INN raqami',
    account: 'Hisob raqami',
    swift: 'SWIFT kodi',
    oknh: 'OKNH',
    mfo: 'MFO',
    add_requisites: 'Yangi rekvizit qo\'shish',
    edit: 'Tahrirlash',
    delete: 'O\'chirish',

  },
  requestdoc: {
    index: 'Ma\'lumotnoma so\'rovchi tashkilotlar',
    new: 'Yaratish',
    update: 'Tahrirlash',
    delete: 'O\'chirish',
    unioncom: 'Kasaba uyushma qo\'mitasiga',
    bank: 'Bankka',
    tmib: 'TMIB ga',
    tmig: 'Tashqi migratsiyaga',
    embassy: 'Elchixonaga',
  },
  user: {
    department_name: 'Bo\'lim nomi',
    roles: 'Rollar',
    index: 'Foydalanuvchilar',
    dialogHeaderText: 'Foydalanuvchilar',
    name: 'Ism sharifi',
    email: 'Elektron pochtasi',
    phone: 'Telefon raqami',
    department_id: 'Bo\'limi',
    role_id: 'Ro\'li',
    position: 'Lavozimi',
    username: 'Login',
    newUser: 'Yangi foydalanuvchi qo\'shish',
    updateUser: 'Tahrirlash',
    employee: 'Xodim',
    "role-permission": 'Rollarda - ruxsatnomani biriktish',
    employee_id: 'Xodim',
    permission: "Ruxsatlar",
    department_code: 'Bo\'lim kodi',
  },
  profile: {
    employee_name: 'F.I.Sh',
    user_name: 'Foydalanuvchi nomi  ',
    key_name: 'Foydalanuvchi nomi  ',
    user_name: 'Foydalanuvchi nomi  ',
    tabel: 'Tabel raqami  ',
    born_date: "Tug'ilgan sanasi  ",
    department: "Bo'lim  ",
    department_code: 'Bo\'lim kodi',
    employee_position: 'Lavozimi  ',
    role: 'Roli  ',
    email: 'Elektron pochta  ',
    imzo: 'Elektron imzo',
    password: 'Parol',
    stir: 'STIR',
    given_date: 'Berilgan sana',
    expere_date: 'Amal qilish muddati',
    push: 'Tanlangan imzoni profilga biriktirish',
    select_key: 'Kalitni tanlang',
    incorrect_login: 'Login yoki parol noto‘g‘ri kiritilgan',
    personal_information: 'Shaxsiy ma\'lumotlari',
    all_documents: 'Barcha hujjatlari',
    family_status: 'Oilaviy holati',
    information: 'Ma\'lumoti',
    order_date: 'Buyruq sanasi',
    order_number: 'Buyruq raqami',
    first_work_date: 'Birinchi ish sanasi',
    adress: 'Manzil',
  },
  permission: {
    index: 'Ruxsatlar',
    name: 'Ruxsat nomi',
    display_name: 'Ko\'rinish nomi',
    description: 'Izox',
    dialogHeaderText: "Yangi ruxsat qo'shish",
    edit: 'Tahrirlash'
  },
  role: {
    index: 'Rollar',
    name: 'Sarlavha roli',
    display_name: 'Ko\'rsatiladigan ism',
    description: 'Eslatma',
    assigned_permissions: 'Belgilangan ruxsatnomalar',
    not_assigned_permissions: 'Tasdiqlanmagan ruxsatnomalar',
    dialogHeaderText: 'Ruxsatnomalarni rolga tayinlang',
    addRole: 'Yangi rol qo\'shish',
  },
  department: {
    name: 'Bo\'lim nomi',
    department_type_id: 'Bo\'lim turi',
    parent_id: 'Asosiy bo\'lim',
    director: "Direktor",
    company_id: 'Tashkilot',
    dialog: 'Bo\'limlar',
    index: 'Bo\'limlar',
    create: 'Yangi bo\'lim yaratish',
    company_name: 'Tashkilot nomi',
    department_code: 'Bo\'lim kodi',
    department_name: 'Bo\'lim nomi',
    departments: 'Bo\'limlar',
    tree: 'Bo\'limlar iyerarhiyasi',
    manager_staff: 'Rahbar shtati',
    management: 'Boshqaruvchi xodimlar',
    director: "Direktor",
    itr: "Inj-tex-xodim",
    restitr: "Inj-tex-xodim qolganlari",
    rab: "Ishchi",
    master: "Master",
    brigadir: "Brigadir",
    worker: "Ishchi",
    internship: "Amaliyotda",
    foreigner: "Xorijliklar",
    maternity: "Dekret",
    women: "Ayollar",
    accountant: "Hisobchi",
    branch: 'Filial',
  },
  departments: {
    name: 'Bo\'lim nomi',
    department_type_id: 'Bo\'lim turi',
    parent_id: 'Asosiy bo\'lim',
    director: "Direktor",
    company_id: 'Tashkilot',
    dialog: 'Bo\'limlar',
    index: 'Bo\'limlar',
    create: 'Yangi bo\'lim yaratish',
    company_name: 'Tashkilot nomi',
    department_code: 'Bo\'lim kodi',
    department_name: 'Bo\'lim nomi',
    departments: 'Bo\'limlar',
    tree: 'Bo\'limlar iyerarhiyasi',
    manager_staff: 'Rahbar shtati',

  },
  company: {
    index: 'Tashkilot',
    dialogHeaderText: 'Tashkilot',
    name: 'Tashkilot nomi',
    newOrganization: 'Yangi tashkilot',
    updateCompany: 'Tashkilotni taxrirlash',
  },
  staff: {
    hr: 'Kadrlar boshqaruvi',
    name_uz_latin: 'O\'zbek lotin',
    name_uz_cyril: 'O\'zbek kiril',
    name_ru: 'Ruscha',
    department_id: 'Bo\'limi',
    position_id: 'Kasb',
    range_id: 'Diapazon',
    personal_type_id: 'Personal turi',
    expence_type_id: 'Xarajat turi',
    rate_count: 'Stavka soni',
    personal_count: 'Personal sanog\'i',
    order_date: 'Buyruq sanasi',
    order_number: 'Buyruq raqami',
    begin_date: 'Boshlanish sanasi',
    end_date: 'Tugallanish sanasi',
    editStaff: 'Taxrirlash',
    newStaff: 'Yangi kiritish',
    staff: 'Shtatlar jadvali',
    staff_admin: 'Tashkiliy boshqaruv',
    index: 'Shtat jadvali',
    admin: 'Admin panel',
    range_code: 'Razryad',
    expence_type: 'Harajat turi',
    personal_type: 'Personal turi',
    employees_count: 'Хodim soni',
    branch_id: 'Filial',
    requirements: 'Kandidat uchun talablar',
    instruction_file_path: 'Yo‘riqnoma fayliga xavola',
    uploadFiles: 'Faylni yuklash',
    fileType: 'Fayl turi',
    file: 'Fayl',
    files: 'Fayllar',
    objectType: 'Ob\'ekt turi',
  },
  documentTypes: {
    list: 'Ro\'yxat',
    name: 'Nomi',
    index: 'Hujjat turlari',
    dialogHeaderText: 'Hujjat turlari'
  },
  document: {
    eimzo_info: "Raqamli imzo haqida ma'lumotlar",
    add_parent_document: 'Aloqador hujjatlar',
    children_document: 'Quyi aloqador hujjatlar',
    add_doer: 'Bajaruvchi qo\'shish',
    document_sending_department: 'Yuboruvchi',
    document_number: 'Tartib raqami',
    letter_number: 'Xat raqami',
    create: 'Yangi hujjat yaratish',
    new_document: 'Yangi hujjat',
    new_document: 'Yangi hujjatlar',
    parent_emlpoyee: 'Yo\'naltiruvchi xodim',
    edit_document: 'Tahrirlash',
    document_type_id: 'Hujjat turi',
    document_created_by: 'Yaratgan foydalanuvchi:',
    created_at: 'Hujjat yaratilgan sana:',
    confirmers: 'Hujjatni tasdiqlovchilar',
    document_receiving_department: 'Qabul qiluvchilar',
    attachments: 'Yuklama',
    title: 'Hujjat sarlavhasi',
    document_content: 'Hujjatning kontent qismi',
    short_content: 'Qisqacha mazmuni',
    number: "Chiquvchi raqam",
    correspondent: "Korrespondent",
    type: "Turi",
    should_receive_all_departments: 'Barcha bo\'limlarga yuborish',
    documents: 'Hujjatlar',
    document_type: 'Turi',
    document_template: 'Hujjat shablonlari',
    document_date: 'Sanasi',
    department: 'Boshqaruv',
    department_send: 'Yuboruvchi',
    department_receiver: 'Qabul qiluvchi',
    index: 'Hujjatlar',
    comment: 'Izohlar',
    assignment: 'Topshiriq',
    content: 'Qisqacha mazmuni',
    reject: 'Bekor qilish',
    documentTypes: 'Hujjat turlari',
    documentTemplates: 'Andozalar',
    action_type: 'Amal',
    signer_sequence: 'Navbat',
    staff: 'Bo\'limlar, lavozimlar',
    signers: 'Imzolovchilar',
    history: 'Hujjat tarixi',
    creator: 'Yaratuvchisi',
    description: 'Hujjat tavsifi',
    assignment: 'Topshiriq',
    reaction: 'Amal',
    update: 'Yangilash',
    resolution: 'Yo\'naltirish',
    resolution_create: 'Yo\'naltirilgan vaqti',
    due_date: 'Muddati',
    files: 'Fayllar',
    add_file: 'Fayl qo\'shish',
    file_name: 'Fayl nomi',
    full_search: 'To\'liq qidiruv',
    accept: 'Tasdiqlayman',
    processing: 'Jarayonda',
    vacancy: 'Bo\'sh joy',
    doc_punkts: 'Hujjat punktlari',
    punkt: 'Punkt',
    add_punkt: 'Punkt qo\'shish',
    resolution_type: "Yo'naltirish turi",
    inboxs: 'Kiruvchi hujjatlar',
    outboxs: 'Chiquvchi hujjatlar',
    drafts: 'Qoralama hujjatlar',
    cancels: 'Bekor qilingan hujjatlar',
    inbox: 'Kiruvchi',
    outbox: 'Chiquvchi',
    draft: 'Qoralama',
    canceled: 'Bekor qilingan',
    all: 'Barchasi',
    allhr: 'Barchasi',
    alllsp: 'Barchasi',
    allznz: 'Barchasi',
    status: 'Status',
    term: 'Muddat (soat)',
    add_signer: 'Imzolovchilarni qo\'shish',
    document_name: 'Hujjat nomi',
    add_parent: 'Bevosita rahbarlarni qo\'shish',
    empty_employee: 'Xodim qo\'shilmadi',
    empty_document_relation: 'Hujjat ilova qilinishi kerak',
    add_employee: 'Xodimni qo\'shing',
    send: 'Yuborish',
    confirmation: 'Tasdiqlash',
    return_to: 'Ijroga qaytarish',
    copy: 'Hujjatdan nusxa olish',
    not_set: 'O\'rnatilmagan',
    start_date: 'Boshlanish sanasi',
    end_date: 'Tugash sanasi',
    new: 'Yangi',
    ok: 'Tasdiqlangan',
    cancel: 'Bekor qilish',
    process: 'Jarayonda',
    doers: 'Ijrochilar',
    doer: 'Ijrochi',
    reaction_status: 'Imzolash statusi',
    doers: 'Bajaruvchilar',
    doer: 'Bajaruvchi',
    pending_action: 'Kutilayotgan harakat',
    total_sum: 'Haqiqiy summa'
  },
  home: {
    home: 'Asosiy',
  },
  tariffScale: {
    index: 'Tarif setkasi',
    dialogHeaderText: 'Tariflar',
    category: 'Kategoriyasi',
    salary: 'Maosh',
    order_date: 'Buyruq sanasi',
    order_number: 'Buyruq raqami',
    create: 'Yangi tarif setkasi qo\'shish',
    edit: 'Tahrirlash'
  },
  coefficient: {
    index: 'Ustamalar',
    dialogHeaderText: 'Ustamalar',
    code: 'Kodi',
    percent: 'Foiz',
    description: 'Izoh',
    order_date: 'Buyruq sanasi',
    order_number: 'Buyruq raqami',
    status: 'Holat',
    begin_date: 'Boshlanish vaqti',
    end_date: 'Tugash muddati',
    create: 'Yangi ustama qo\'shish',
    edit: 'Tahrirlash',
    type: 'Ustama turi',

  },
  departmentTypes: {
    index: 'Bo\'lim turlari',
    dialogHeaderText: 'Bo\'lim turlari',
    create: 'Yangi bo\'lim turi kiritish',
    edit: 'Tahrirlash'
  },
  personalType: {
    index: 'Personal turlari',
    dialogHeaderText: 'Personal turlari',
    create: 'Yangi personal turi kiritish',
    edit: 'Tahrirlash'
  },
  positionType: {
    index: 'Kasblar turlari',
    dialogHeaderText: 'Kasblar turlari',
    code: 'Kodi',
    create: 'Yangi kasb turini kiritish',
    edit: 'Tahrirlash'
  },
  position: {
    index: 'Shtatlar',
    updatePosition: 'Tahrirlash',
    newPosition: 'Yangi shtat qo\'shish',
  },
  expenceType: {
    index: 'Xarajat turlari',
    dialogHeaderText: 'Xarajat turlari',
    create: 'Yangi xarajat turi qo\'shish',
    edit: 'Tahrirlash',
  },
  ranges: {
    index: 'Diapazonlar',
    dialogHeaderText: 'Diapazon',
    code: 'Kodi',
    name: 'Diapazon nomi',
    minfond: 'Minfond',
    maxfond: 'Maxfond',
    order_date: 'Buyruq sanasi',
    order_number: 'Buyruq raqami',
    create: 'Yangi diapazon kiritish',
    edit: 'Tahrirlash'
  },
  recruitment: {
    index: 'Ishga yollash',
  },
  transfer: {
    index: 'Tarjima',
  },
  dismissal: {
    index: 'Ishdan bo\'shatish',
  },
  countries: {
    index: 'Davlat',
    dialogHeaderText: 'Davlat',
    country_code: 'Davlat kodi',

  },
  districts: {
    index: 'Shahar/tuman',
    region_id: 'Viloyat',
    dialogHeaderText: 'Shahar/tuman'
  },
  regions: {
    index: 'Viloyat',
    dialogHeaderText: 'Viloyat',
    country_id: 'Davlat',
    region_id: 'Viloyat',
  },
  natioanalities: {
    index: 'Millat',
    dialogHeaderText: 'Millat',
    name_uz_latin: 'O\'zbekcha lotin',
  },
  organization: {
    index: 'Tashkilot',
    newOrganization: 'Yangi tashkilot qo\'shish',
    updateOrganization: 'Tahrirlash',
  },
  employeeDocument: {
    index: 'Xodimning hujjatlari',
    tabel: 'Tabel raqami :',
    born_date: "Tug'ilgan sanasi :",
    department: "Bo'lim :",
    employee_position: 'Lavozimi :',
    series: 'Seriya',
    number: 'Raqam',
    given_by: 'Kim tomonidan berilgan',
    date_issue: 'Berilgan sana',
    valid_until: 'Amal qilish muddati',
    status: 'Status',
    actions: 'Amal',
    addEmployeeDocument: "Yangi hujjatlar qo'shish",
    updateEmployeeDocument: 'Tahrirlash',
    docType: 'Hujjat turi',
    title: 'Sarlavha',
    files: 'Fayllar',
    uploadFiles: 'Fayllarni yuklash',
  },
  employee: {
    index: 'Xodim',
    deletedIndex: 'Ishdan ketgan hodimlar',
    name: 'Xodim',
    Company: 'Tashkilot',
    company_id: 'Tashkitlot',
    country_id: 'Davlat',
    Nationality: 'Millati',
    nationality_id: 'Millati',
    region_id: 'Viloyati',
    district_id: 'Shahar/tuman',
    address: 'Manzili',
    tabel: 'Tabel raqami',
    firstname_uz_latin: 'Ismi lotincha',
    lastname_uz_latin: 'Familyasi lotincha',
    middlename_uz_latin: 'Otasining ismi lotincha',
    firstname_uz_cyril: 'Ismi kiril',
    lastname_uz_cyril: 'Familyasi kiril',
    middlename_uz_cyril: 'Otasining ismi kiril',
    firstname: 'Ismi',
    lastname: 'Familiyasi',
    middlename: 'Otasining ismi',
    born_date: "Tug'ilgan sanasi",
    INN: 'INN',
    INPS: 'INPS',
    filter: 'Qidiruv',
    born_date_from: 'Tug\'ilgan sanasi(dan)',
    born_date_to: "Tug'ilgan sanasi(gacha)",
    department_id: 'Bo\'limlar',
    category: 'Kategoriyasi',
    shifr: 'Shifr',
    contract_number: 'Shartnoma raqami',
    contract_date: 'Shartnoma sanasi',
    position: 'Lavozimi',
    main_staff: 'Asosiy shtatda',
    loaded_staff: 'Yuklatilgan shtatda',
    contractDate: 'Meh.shart. sanasi',
    contractNumber: 'Meh.shart. No.',
    enterOrderDate: 'Buyruq sanasi',
    enterOrderNumber: 'Buyruq raqami',
    coefficients: 'Ustamalar',
    all: 'Jami',
    enter_order_date: 'Buyruq No',
    enter_order_number: 'Buyruq sanasi',
    percent: 'Miqdori(%)',
    description: 'Izoh',
    status: 'Status',
    begin_date: 'Boshl. sanasi',
    end_date: 'Tugash sanasi',
    active: 'Aktiv',
    inactive: 'No aktiv',
    addresses: 'Manzillar',
    country: 'Respublika',
    region: 'Viloyat',
    district: 'Tuman',
    street_address: 'Mahalla',
    street_address_uz_latin: 'Mahalla lotinchada',
    street_address_uz_cyril: 'Mahalla kirilchada',
    street_address_ru: 'Mahalla ruschada',
    home_address: 'Uy',
    home_address_uz_latin: 'Lotinchada Uy manzili',
    home_address_uz_cyril: 'Kirilchada Uy manzili',
    home_address_ru: 'Ruschada Uy manzili',
    staff_id: 'Shtat',
    tariff_scale_id: 'Tarif rejasi',
    first_work_date: 'Ishga qabul qilish sanasi',
    leave_order_number: 'Ishdan bo\'shatish buyruq raqami',
    leave_order_date: 'Ishdan bo\'shatish to\'g\'risidagi buyruq sanasi',
    newEmployeeStaff: 'Ishga yollash',
    editEmployee: 'Tahrirlash',
    is_main_staff: 'Asosiy xodimlar',
    employee_staff: "Shtatlar",
    range: 'Bo\'shatish',
    editEmployeeStaff: 'Xodimlar tarkibini tahrirlash',
    editemployeeCoefficient: 'Xodimning nafaqalarini tahrirlash',
    editEmployeeAddress: 'Xodimning manzilini tahrirlash',
    newEmployeeCoefficient: 'Xodimning nafaqasini yaratish',
    address_type_id: 'Manzil turi',
    order_date: 'Buyurtma sanasi',
    newEmployeeAddress: 'Xodimning manzilini yaratish',
    personalInformation: 'Shaxsiy ma\'lumotlar',
    education: 'Ta\'lim malaka',
    spravka: 'Ma\'lumotnomalar',
    family: 'Oilaviyligi',
    work_exprience: 'Ish faoliyati',
    hr: 'Kadr Hujjatlari',
    military: 'Xarbiy hisob',
    taxes: 'Daromad solig\'i',
    fullname: 'F.I.O.',
    info: 'Xodim',
    new_employee: 'Yangi xodim',
    birth_address: "Tug'ilgan manzili",
    residence_address: "Yashash manzili",
    employee_phones: 'Xodim telefonlari',
    phones: 'Telefonlar',
    phone: 'Telefon',
    phone_type: 'Telefon turi',
    phone_number: 'Telefon raqami',
    add_new_phone: 'Yangi telefon qo\'shish',
    dismissal: 'Ishdan bo\'shatish',
    leave_date: 'Ishdan bo\'shash sanasi',
    leave_order_date: 'Buyruq sanasi',
    leave_order_number: 'Buyruq raqami',
    leaving_reason_id: 'Ishdan bo\'shash sababi',
    info: 'Xodim haqida ma\'lumot'
  },
  signerGroup: {
    signer_group_id: 'Imzo qoyuvchilar guruhi',
    new_signer_group: 'Imzolovchilar guruhini yarating',
    edit_signer_group: 'Imzolovchilar guruhini tahrirlash',
    staff_list: 'Xodimlar ro\'yxati',
    add_signer: 'Imzolovchilarni qo\'shish',
  },
  documentTemplates: {
    signers: 'Imzolovchilar shtatlari',
    index: 'Hujjat shablonlari',
    sequence: 'Navbat',
    attribute_name_uz_latin: 'Atributning nomi (uzb lotin)',
    attribute_name_uz_cyril: 'Atributning nomi (Uzbek Kiril)',
    attribute_name_ru: 'Atribut nomi (rus)',
    data_type_id: 'Sana turi',
    value_min_length: 'Min. qiymati uzunligi',
    value_max_length: 'Maks. qiymati uzunligi',
    description: 'Tavsif',
    attributeName: 'Atribut nomi',
    sign_type: 'Imzolash turi',
    registry_type: 'Reestr',
  },
  document_detail_attributes: {
    index: 'Xususiyatlar',
  },
  document_detail_templates: {
    index: 'Tafsilotlar',
    content: 'Tarkib',
    attribute_name_uz_latin: 'Atributning nomi (uzb lotin)',
    attribute_name_uz_cyril: 'Atributning nomi (Uzbek Kiril)',
    attribute_name_ru: 'Atribut nomi (rus)',
    data_type_id: 'Sana turi',
    value_max_length: 'Min. qiymati uzunligi',
    value_min_length: 'Maks. qiymati uzunligi',
    description: 'Tavsif',
    content_uz_latin: "Tarkibi o'zbek lotin",
    content_uz_cyril: "Tarkibi o'zbek kiril",
    content_ru: "Tarkibi ruscha",
    is_list_vertical: "Vertikal holda ko'rsatiladimi?",
    is_registry_show: "Reisterda ko'rsatiladimi?",
    is_show: "Ko'rsatiladimi?",
  },
  actionTypes: {
    index: 'Faoliyat turlari',
    sequence: 'Ketma-ketlik',
  },
  requirementType: {
    index: 'Talab turlari',
    create: 'Yangi qo\'shish',
    edit: 'Tahrirlash',
    dialogHeaderText: 'Talab turlari',
  },
  requirement: {
    index: 'Ishga qo\'yiladigan talablar',
    type: 'Talab turi',
    dialogHeaderText: 'Ishga qo\'yiladigan talablar',
    requirement_type_id: 'Talab turi',
    newrequirement: 'Talablarni yarating',
    updaterequirement: 'Talablarni tahrirlash',
  },
  appeal_content: {
    index: 'Shikoyat mazmuni',
    create: 'Yangi qo\'shish',
    edit: 'Tahrirlash',
    dialogHeaderText: 'Shikoyat mazmuni'
  },
  object_type: {
    index: 'Obyekt turlari',
    create: 'Yangi obyekt qo\'shish',
    edit: 'Tahrirlash',
    dialogHeaderText: 'Yangi obyekt qo\'shish'

  },
  purchase_catalogs: {
    catalogs: 'Xarid kataloglari',
    add_catalog: 'Xarid katalogi qo\'shish ',
    edit_catalog: 'Xarid katalogini tahrirlash',
    code: 'Kodi',
    part_number: 'Detal raqami',
    description: 'Izoh',
    material_content: 'Material tarkibi',
    name_eng: 'Nomi ingliz tilida',
    name_ru: 'Nomi rus tilida',
    specification: 'Spetsifikatsiyasi',
    short_name: 'Qisqa nomi',
    using_location: 'Joylashuvdan foydalanish',
    using_purpose: 'Maqsadli foydalanish',
    measure: 'O\'lchov',
    manufacturer: 'Ishlab chiqaruvchi',
  },
  reasons: {
    index: 'Ishdan bo\'shatilish sabablari',
    newReasons: 'Ishdan bo\'shatilish sabablarini qo\'shish',
    updateReasons: 'Ishdan bo\'shatilish sabablarini tahrirlash',

  },
  dismissed: {
    employee: 'Ishdan bo\'shatilgan xodimlar',
  },
  partners: {
    index: 'Hamkorlar',
    name: 'Nomi',
    adress: 'Manzil',
    bank_name: 'Bank nomi',
    bank_adress: 'Bank manzili',
    account: 'Hisob raqami',
    swift_code: 'SWIFT kodi',
    mfo: 'MFO',
    inn: 'INN',
    add_partners: 'Yangi hamkor qo\'shish',
    edit: 'Tahrirlash'
  },

  report: {
    create_document: "Yaratilgan hujjatlar",
    expired: 'Muddati o\'tgan',
    prosesing: 'Qayta ishlash',
    waiting: 'Kutish',
    completed_on_time: 'Vaqtida bajarilgan',
    failed_in_time: 'Vaqtida bajarilmagan',
  },

  currency: {
    index: 'Valyutalar',
    title: 'Valyuta turlari',
    name: 'Nomi',
    code: 'Kodi',
    description: 'Tavsifnoma',
    add: 'Yangi valyuta turi qo\'shish',
    edit: 'Tahrirlash',
    delete: 'Siz ushbu valyuta turini o`chirishga aminmisiz?',
    history: 'Valyutalar tarixi',
    price: 'Kurs',
    date: 'Sana',
    search: 'Qidiruv',
    oper: 'Amallar',
  },
  notification: {
    index: 'Xabarnomalar',
    content: 'Tarkib',
    is_active: 'Xolat',
    create: 'Yangi xabarnoma qo\'shish',
    edit: 'Tahrirlash',
    delete: 'Siz ushbu xabarnomani o\'chirishga aminmisiz?',
  },
  accessDepartment: {
    index: 'Xodimlar ruxsati',
    employee: 'Xodimlar ro\'yxati',
    department: 'Bo\'limlar ro\'yxati',
    access: 'Ruxsatlar',
    accessType: 'Ruxsat turi',
    create: 'Yangi ruxsat qo\'shish',
    tabel: 'Tabel raqami',
  },
  accessType: {
    index: 'Ruxsat turlari',
    create: 'Yangi ruxsat turi qo\'shish',
    edit: 'Tahrirlash',
  },
  registry: {
    index: 'Reestr',
    vacation:"Tatil buyrug' reestri",
    business_trip:"H.safari buyrug' reestri",
    work_calendar: 'Ish kalendari',
  },
  carPurchase: {
    ERI:'Elektron imzo olish',
    index: 'Avtomobil sotib olish uchun ariza',
    view: 'Avtomobil uchun ariza',
    employee: 'Xodim',
    carModel: 'Avtomobil modeli',
    comment: 'Izoh',
    status: 'Xolat',
    regStatus: 'Reestr xolati',
    accEmployee: 'Xisobchi',
    employeeId: 'Xodim',
    file: 'Fayl',
    files: 'Fayllar',
    create: 'Yangi ariza qo\'shish',
    createdBy: 'Yaratgan foydalanuvchi',
    createdAt: 'Sana',
    department: 'Bo\'lim',
    position: 'Lavozim',
    edit: 'Tahrirlash',
  },
  company_requisites: {
    name_uz_latin: 'Nomi o\'zbek lotin',
    name_uz_cyril: 'Nomi o\'zbek kiril',
    name_ru: 'Nomi ruscha',
    name: 'Nomi',
    address_name_uz_latin: 'Manzil o\'zbek lotin',
    address_name_uz_cyril: 'Manzil o\'zbek kiril',
    address_name_ru: 'Manzil ruscha',
    address: 'Manzili',
    inn: 'INN raqami',
    account: 'Hisob raqami',
    swift: 'SWIFT kodi',
    oknh: 'OKNH',
    mfo: 'MFO',
    add_requisites: 'Yangi rekvizit qo\'shish',
    edit: 'Tahrirlash',
    delete: 'Удалить',
  },
  reportDepartment: {
    all: 'Barchasi',
    published: 'E\'lon qilingan',
    processing: 'Jarayonda',
    signed: 'Imzolangan',
    ready: 'Tayyor',
    completed: 'Yakunlangan',
    cancelled: 'Rad edilgan'
  },
  familyRelatives: {
    index: 'Oilaviy qarindoshlar',
    status: 'Holat',
    add: 'Oilaviy qarindoshlar qo\'shish',

  },
  inventory: {
    index: 'Inventarizatsiya',
    warehouse: 'Ombor',
    comission: 'Komissiya',
    blank_number: 'Blanka raqami',
    part_number: 'Part NO',
    product_name: 'Masxulot nomi',
    real_stock: 'Sanoq',
    address: 'Adres',
    addressName: 'Adres nomi',
    delete: 'Siz ushbu adresni o\'chirishga aminmisiz?',
    product: 'Maxsulotlar ro\'yxati',
    partNumber: 'Detal raqami',
    productName: 'Maxsulot nomi',
    stock: 'Qoldiq',
    unitMeasure: 'O\'lchov birligi',
    report: 'Hisobot',
    commission: 'Komissiya',
    blank: 'Blankalar'
  },
  directory: {
    index: 'Jurnallar',
    type: 'Jurnal turi',
  }

};

module.exports = uz_latin
